import {
  Grid,
  space,
  theme,
  Typography,
} from "@waldner-laboreinrichtungen/component-system";
import { t } from "i18next";
import styledComponents from "styled-components";

import type { FunctionGridProps } from "../../partials/function-grid.tsx";
import type { Channel } from "../../view-model.ts";
import {
  getPortValue,
  renderFunction,
} from "../common/function-grid-helpers.tsx";

const StyledGroupContainer = styledComponents.div`
  border: 1px solid ${theme.colorPalette.grey200};
  border-radius: ${theme.borderRadius.default};
  padding: ${space(4)} ${space(2)} ${space(2)} ${space(2)};
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const StyledGroupHeader = styledComponents(Typography)`
  position: absolute;
  top: 0;
  right: ${space(4)};
  transform: translateY(-50%);
  background: #fff;
  padding: 0 ${space(3)};
  z-index: 1;
`;

const StyledOuterGrid = styledComponents(Grid)`
  height: 100%;
`;

const StyledInnerGrid = styledComponents(Grid)`
  flex: 1;
  grid-row-gap: ${space(2)};
  grid-column-gap: 0;
  height: 100%;
`;

const SPIDER_PORTS = ["first", "second", "third", "fourth"] as const;

type SpiderPort = (typeof SPIDER_PORTS)[number];

function getPort(channel: Channel): SpiderPort | undefined {
  return getPortValue(channel, SPIDER_PORTS);
}

export function FunctionGrid({
  functions,
  incidents,
  onSelect,
}: FunctionGridProps): JSX.Element {
  const portFunctions = SPIDER_PORTS.map((port) =>
    functions.filter((f) => getPort(f) === port)
  );

  return (
    <StyledOuterGrid rowGap={space(3)}>
      {portFunctions.map((group, index) => {
        const port = SPIDER_PORTS[index];
        return (
          <Grid.Column key={port} width={3}>
            <StyledGroupContainer>
              <StyledGroupHeader>
                <Typography color="grey500" size="lg" weight="medium">
                  {t(`channel.${port}`)}
                </Typography>
              </StyledGroupHeader>
              <StyledInnerGrid>
                {group.length > 0 ? (
                  group.map((channel) =>
                    renderFunction(channel, onSelect, 12, incidents)
                  )
                ) : (
                  <Typography color="grey400" size="sm">
                    {t("channel.empty")}
                  </Typography>
                )}
              </StyledInnerGrid>
            </StyledGroupContainer>
          </Grid.Column>
        );
      })}
    </StyledOuterGrid>
  );
}
